<template>
    <el-table
        :empty-text="$t.__('documents.overview.tab.dunning.DunningList.no_data')"
        :data="this.dunnings"
    >
        <el-table-column :label="$t.__('common.labels.date')" width="140">
            <template slot-scope="scope">
                {{ scope.row.date | dateFormatter('SLASHED_DATE_TIME') }}
            </template>
        </el-table-column>
        <el-table-column
            prop="name"
            :label="$t.__('documents.overview.tab.dunning.DunningList.dunning')"
        >
        </el-table-column>
        <el-table-column
            v-if="hasDeadlines"
            :label="$t.__('documents.overview.tab.dunning.DunningList.due_date')"
        >
            <template slot-scope="scope">
                {{ getDeadlineInfo(scope.row.deadline_id) }}
            </template>
        </el-table-column>
        <el-table-column
            prop="sender"
            :label="$t.__('documents.overview.tab.dunning.DunningList.sender')"
        >
        </el-table-column>
        <el-table-column
            prop="recipient"
            :label="$t.__('documents.overview.tab.dunning.DunningList.recipient')"
        >
        </el-table-column>
    </el-table>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('documentOverview');

export default {
    props: {
        dunnings: {
            required: true,
            type: Array,
        },
    },
    computed: {
        ...mapState({
            deadlines: (state) => state.deadlines,
        }),
        hasDeadlines() {
            return (
                Object.keys(this.deadlines).length &&
                this.dunnings.filter((row) => row.deadline_id !== null).length
            );
        },
    },
    methods: {
        getDeadlineInfo(id) {
            if (!this.deadlines[id]) {
                return '';
            }
            let deadline = this.deadlines[id];
            return deadline['date_formatted'];
        },
    },
};
</script>
